import getWTId from './wt_id';
import $ from 'cash-dom';

export class WT {
  cache = [];
  wtEnabled = true;
  constructor(cmp) {
    // MARK: WT deaktivieren
    if (location.hostname !== 'abo.wiwo.de') {
      console.log('[WT] is disabled.');
      return;
    }
    this.cmp = cmp;
    this.wtConsent = false;
    const trackId = getWTId();
    const isPreview = this.getQueryParameter('preview') === 'true';
    if (isPreview) {
      console.warn('[WT] in preview mode is not enabled!');
    }
    this.wtEnabled = !!trackId && !isPreview;
    this.cmp.waitForGrant('5e7e5243b8e05c48537f606b').then(() => {
      this.webtrekkConfig = {
        trackId,
        trackDomain: 'wt.vhb.de',
        domain: location.hostname,
        cookie: '1',
        executePluginFunction: '',
      };
      window.webtrekkConfig = this.webtrekkConfig;
      this.wt = new webtrekkV3();

      const wtEid = this.getQueryParameter('hmg_cid');
      if (wtEid) {
        this.wt.setEverId(wtEid);
      }

      //
      this.wtConsent = true;
      this.initWT();
      this.flush();
    });
  }

  flush() {
    const cache = [...this.cache];
    this.cache = [];
    for (const [method, ...args] of cache) {
      //console.log(`CALL ${method} with ${args}`);
      this[method].apply(this, args);
    }
  }

  initWT() {
    console.log('INIT WT?');
    // track page load?
    // this.trackPage();
  }

  get canWT() {
    return this.wtConsent && this.wtEnabled;
  }

  trackPage({ customParam1, contentId, customParam2 } = {}) {
    // get page name from Meta?



    if (this.canWT) {
      if (contentId !== undefined) {
        this.wt.contentId = contentId;
      }

      this.wt.customParameter = {
        1: customParam1,
        2: customParam2,
      };

      this.wt.sendinfo();

    } else {

      this.cache.push(['trackPage',{ customParam1, contentId, customParam2 }]);
    }
  }

  action(params = {}) {
    //console.log('Action', params);
    if (this.canWT) {
      this.wt.sendinfo(params);
    } else {
      this.cache.push(['action', params]);
    }
  }

  getQueryParameter(name, url = undefined) {
    if (!url) {
      url = window.location.href;
    }
    name = name.replace(/[\[\]]/g, '\\$&');
    const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
      results = regex.exec(url);
    if (!results) {
      return null;
    }
    if (!results[2]) {
      return '';
    }
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
  }

  extractHostName(url) {
    let hostname;
    if (url.indexOf('://') > -1) {
      hostname = url.split('/')[2];
    } else {
      hostname = url.split('/')[0];
    }
    hostname = hostname.split(':')[0];
    hostname = hostname.split('?')[0];
    return hostname;
  }
}
